<template>
  <q-page padding>
    <div class="row">
      <q-table
        title="Temas"
        :rows="themes"
        :columns="columnsThemes"
        row-key="id"
        class="col-12"
        :loading="loading"
      >
        <template v-slot:top>
          <span class="text-h6">Temas</span>
          <q-space />
          <q-btn
            v-if="$q.platform.is.desktop"
            dense
            icon="add"
            alt="Adicionar temas"
            color="positive"
            size="sm"
            :to="{name: 'form-theme'}"
          >
            <q-tooltip>
              Adicionar tema
            </q-tooltip>
          </q-btn>
        </template>
        <template v-slot:body-cell-actions="props">
          <q-td :props="props">
            <div class="q-gutter-x-md">
              <q-btn
                icon="edit"
                alt="Editar"
                color="info"
                dense
                size="sm"
                @click="handleEditTheme(props.row)"
              >
                <q-tooltip>
                  Editar tema
                </q-tooltip>
              </q-btn>
              <q-btn
                icon="delete"
                alt="Remover"
                color="negative"
                dense
                size="sm"
                @click="handleRemoveTheme(props.row)"
              >
                <q-tooltip>
                  Remover tema
                </q-tooltip>
              </q-btn>
            </div>
          </q-td>
        </template>
      </q-table>
    </div>
    <q-page-sticky
      position="bottom-right"
      :offset="[18, 18]"
      v-if="$q.platform.is.mobile"
    >
      <q-btn
        fab
        icon="add"
        color="positive"
        padding="md"
        :to="{name: 'form-theme'}"
      >
        <q-tooltip>
          Adicionar tema
        </q-tooltip>
      </q-btn>
    </q-page-sticky>
  </q-page>
</template>
<script>
import { defineComponent, ref, onMounted } from 'vue'
import useApi from '../../composables/UseApi'
import useNotify from '../../composables/UseNotify'
import { useRouter } from 'vue-router'
import { useQuasar } from 'quasar'
import { columnsThemes } from './table'

export default defineComponent({
  name: 'PageListTemas',

  setup () {
    const table = 'Tema'
    const themes = ref([])
    const router = useRouter()
    const { list, remove } = useApi()
    const { notifyError, notifySuccess } = useNotify()
    const loading = ref(true)
    const $q = useQuasar()

    const handleListThemes = async () => {
      try {
        loading.value = true
        themes.value = await list(table)
        loading.value = false
      } catch (error) {
        notifyError(error.message)
      }
    }

    const handleEditTheme = (theme) => {
      router.push({ name: 'form-theme', params: { id: theme.id } })
    }

    const handleRemoveTheme = async (theme) => {
      try {
        $q.dialog({
          title: 'Confirme',
          message: `Você realmente deseja remover  ${theme.name}?`,
          cancel: true,
          persistent: true
        }).onOk(async () => {
          try {
            await remove(table, theme.id)
            notifySuccess('Tema removida com sucesso!')
            handleListThemes()
          } catch (error) {
            notifyError(error.message)
          }
        })
      } catch (error) {
        notifyError(error.message)
      }
    }

    onMounted(async () => {
      handleListThemes()
    })

    return { columnsThemes, themes, loading, handleEditTheme, handleRemoveTheme }
  }
})
</script>
